import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import {QRtagGeneration } from './Pages';

export const QRtagRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={QRtagGeneration} />
       
    </Fragment>
)